import PartyNews from '../partyNews/src/index.vue'

export default PartyNews